import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { NotificationIdentifier } from '@evorait/pace-core';
import { ParticipantCopy, ParticipantCopyId, ParticipantParticulars } from '../../types/participant-copy';

export interface ConfirmationInterface {
    getParticipantsFromAttendees(notificationId: NotificationIdentifier): Observable<ParticipantParticulars[]>;
    saveAttendee(notificationId: NotificationIdentifier, participant: ParticipantCopy): Observable<void>;
    removeAttendee(
        notificationId: NotificationIdentifier,
        participant: ParticipantCopyId,
    ): Observable<ParticipantCopyId>;
}

export const ConfirmationInstanceToken = new InjectionToken<ConfirmationInterface>('ConfirmationInterface');
